module.exports = __webpack_public_path__ + "static/media/client4.3135ace0.jpg";